import onReady from '../utils/onReady';
import NoUiSlider from 'nouislider';


/**
 * Boilerplate class demonstrating basic construction.
 * You can expand from here, or find verbose examples in example.js.
 *
 * @param {HTMLElement} container
 * @constructor
 */
class RangeSlider {

    /**
     * The constructor is fired once the class is instantiated.
     *
     * @param {HTMLElement} container
     */
    constructor(container) {
        // Run initializing code once the DOM is ready.
        onReady(() => this.init(container));

        // You can put other initializer-code here if it isn't dependent on the DOM in any way.
    }

    createSlider() {

        NoUiSlider.create(this.dom.slider, {
            start: [this.sliderSettings.min, this.sliderSettings.max],
            step: this.sliderSettings.step,
            margin: this.sliderSettings.margin,
            range: {
                'min': this.sliderSettings.min,
                'max': this.sliderSettings.max
            }
        });

        // Add label to the handles to mark the relationship between them and the heading
        const handleLower = this.dom.slider.querySelector('[data-handle="0"]');
        const handleUpper = this.dom.slider.querySelector('[data-handle="1"]');
        handleLower.setAttribute("aria-labelledby", this.sliderSettings.labelledby);
        handleUpper.setAttribute("aria-labelledby", this.sliderSettings.labelledby);
    }

    showValues() {
        this.dom.slider.noUiSlider.on('update', ( values, handle ) => {
            if(handle) {
                let value = Math.floor(values[handle]);
                this.dom.sliderValueUpperText.innerHTML = value;
                this.dom.sliderValueUpperInput.value = value;
            } else {
                let value = Math.floor(values[handle]);
                this.dom.sliderValueLowerText.innerHTML = value;
                this.dom.sliderValueLowerInput.value = value;
            }
        });
    }

    addEvents() {
        this.dom.container.addEventListener('slider-reset', () => this.resetValues());
        this.dom.container.addEventListener('slider-set', event => this.setValues(event));
    }

    setValues(event) {
        this.dom.slider.noUiSlider.set([event.detail.min, event.detail.max]);
    }

    resetValues() {
        this.dom.slider.noUiSlider.set([this.sliderSettings.min,this.sliderSettings.max]);
    }


    /**
     * The actual initialization function, fired once the DOM is ready.
     *
     * @param {HTMLElement} container
     */
    init(container) {

        this.dom = {
            container // ES6 allows this syntax instead of writing "container: container"
        };


        // Put your other DOM-specific initializations here, and get your class moving!
        this.dom.slider = this.dom.container.querySelector(".noUiSlider");
        this.dom.sliderValueLower = this.dom.container.querySelector(".filter__slider__value--lower");    // Get the elements where the slider values are to be shown
        this.dom.sliderValueUpper = this.dom.container.querySelector(".filter__slider__value--upper");
        this.dom.sliderValueLowerText = this.dom.sliderValueLower.querySelector("p");
        this.dom.sliderValueLowerInput = this.dom.sliderValueLower.querySelector("input");
        this.dom.sliderValueUpperText = this.dom.sliderValueUpper.querySelector("p");
        this.dom.sliderValueUpperInput = this.dom.sliderValueUpper.querySelector("input");

        this.sliderSettings = {
            min: Number(this.dom.container.getAttribute("data-slider-min")),
            max: Number(this.dom.container.getAttribute("data-slider-max")),
            step: Number(this.dom.container.getAttribute("data-slider-step")),
            margin: Number(this.dom.container.getAttribute("data-slider-margin")),
            labelledby: this.dom.container.getAttribute("data-slider-labelledby")
        };

        this.createSlider();
        this.showValues();
        this.addEvents();
    }
}


export default RangeSlider;